import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import myAccountActions from 'redux/actions/myAccountActions'
import Modalizer from 'components/modalizer/modalizer'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import NearpodPicker from 'components/nearpod_picker/nearpod_picker'

class MyAccountNearpodPicker extends Component {

	constructor() {
		super()
		this.closeModal = this.closeModal.bind(this)
		this.onFilePicked = this.onFilePicked.bind(this)
		this.onFileError = this.onFileError.bind(this)
	}

	closeModal() {
		this.props.actions.closeModal()
	}

	onFilePicked(file) {
		this.props.actions.filePicked(['image'], file, 'User')
	}

	onFileError(message) {
		this.props.actions.fileError(message)
	}

	render() {
		return (
			<Modalizer width='570px' height='564px' nopadding={true} closeAction={this.closeModal}>
				<NearpodPicker
					onFilesPicked={this.onFilePicked}
					closeHandler={this.closeModal}
					pickerType={'image'}
					accept={['image']}
					multiselect={false}
					onFileError={this.onFileError}
				/>
			</Modalizer>
		)
	}
}

MyAccountNearpodPicker.propTypes = {
	modalName: PropTypes.string,
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: myAccountActions.closeNearpodPicker,
		filePicked: myAccountActions.uploadProfileImage,
		fileError: myAccountActions.uploadProfileImageError,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyAccountNearpodPicker)
